module.exports = __webpack_public_path__ + "nc.5bfaf7a280690742d758.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/nc.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/nc.svg
// module chunks = styles